import * as React from 'react';
import { useTheme } from '@emotion/react';
import { motion } from 'motion/react';
import { StoryScene } from '../story';

interface TransformationArtworkProps {
  scene: StoryScene;
  reducedMotion: boolean;
}

export const TransformationArtwork: React.FC<TransformationArtworkProps> = ({ scene, reducedMotion }) => {
  const theme = useTheme();
  const colors = theme.featureGraph;
  return (
    <motion.g
      initial={false}
      animate={{ opacity: scene >= StoryScene.TRANSFORMATION ? 1 : 0 }}
      transition={{ duration: reducedMotion ? 0 : 0.7 }}
    >
      <rect
        x="-460"
        y="-130"
        width="1820"
        height="1000"
        rx="32"
        fill="none"
        stroke={colors.feature.border}
        strokeWidth="2"
      />
      <text x="450" y="-65" textAnchor="middle" fill={colors.feature.accent} fontSize="38" fontWeight="600">
        Digital transformation
      </text>
      <text x="450" y="-25" textAnchor="middle" fill={theme.text.paragraph} fontSize="18">
        Connected teams. Automated operations. A governed business.
      </text>
    </motion.g>
  );
};
